import { app } from '../../../bootstrap/core';
import { addressComponent } from './address.component';

app.component('address', addressComponent);
